import { Injectable } from "@angular/core";

import { Observable, catchError } from "rxjs";

import { ApiResponse, RequestOptions, TemplateHelper } from "@venecia/apis/base";

import { ApiTemplate } from "../base/template/api.template";
import { Profile, ProfileRequest } from "./model/profile.model";
import { RoleReference } from "./model/role.model";

@Injectable({ providedIn: 'root' })
export class ProfileApi extends ApiTemplate<Profile, ProfileRequest> {
    constructor() {
        super('http.rest.identity.url', "/api/profiles");
    }

    updateRoles(profileId: number, roles: readonly ProfileRoleIdPayload[], options?: RequestOptions): Observable<ApiResponse<Profile>> {
        const url = this.urlBuilder!.build(`${profileId}/roles`);
        const httpOptions = TemplateHelper.buildOptions(options);

        return this.http
            .put<ApiResponse<Profile>>(url, roles, httpOptions)
            .pipe(
                TemplateHelper.applyRetry(options),
                catchError((err) => TemplateHelper.handleError(err))
            );
    }
}

export interface ProfileRoleIdPayload extends RoleReference {
    id: number;
}
